import { appConfig } from '~/appConfig';
import AbstractLocalRepository from '~base/AbstractLocalRepository';

export default class AccessTokenLocalRepository extends AbstractLocalRepository {
  tableName(): string {
    return appConfig.accessTokenStorageKey;
  }
}
